export class HTTPError extends Error {
  public readonly name: string = 'HTTPError';

  public constructor(public readonly status: number, message: string, options?: ErrorOptions) {
    super(message, options);

    this.name = `HTTPError ${status}`;
  }
}
